import { Typography } from "@kyan/ui";

import { formatValue } from "#/utils/valueFormatters";

interface PriceProps {
  price: number;
  label: string;
}

export const Price: React.FC<PriceProps> = ({ price, label }) => {
  return (
    <div className="flex justify-between">
      <Typography grotesk size={12}>
        {label}
      </Typography>

      <div className="flex gap-1">
        <Typography grotesk primary size={12}>
          {formatValue(price)}
        </Typography>
        <Typography grotesk size={12}>
          USD
        </Typography>
      </div>
    </div>
  );
};
